import { useLayoutEffect, useState } from 'react';

export const TAILWIND_BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
};

type Return = {
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
  isExtraLarge: boolean;
  width: number;
};

const useBreakpoints = () => {
  const [breakpoint, setBreakpoint] = useState<Return>({
    isSmall: false,
    isMedium: false,
    isLarge: false,
    isExtraLarge: false,
    width: 0,
  });

  useLayoutEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setBreakpoint({
        isSmall: width < TAILWIND_BREAKPOINTS.sm,
        isMedium: width < TAILWIND_BREAKPOINTS.md,
        isLarge: width < TAILWIND_BREAKPOINTS.lg,
        isExtraLarge: width < TAILWIND_BREAKPOINTS.xl,
        width,
      });
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return breakpoint;
};

export default useBreakpoints;
